import React from "react";
// import logo from "../../assets/logo-alt.png";
// import logo_white from "../../assets/flint_logo_white.jpeg";
// import logo_white from "../../assets/flint_logo_white.jpeg";
import logo_white from "../../assets/FlintWhiteLogo1.png";

import { Link, useNavigate } from "react-router-dom";
import { SocialMedia } from "../../utils/SocialMedia";

const Footer = () => {
  let Icons = [
    // { name: "logo-twitter", link: "#" },
    { name: "logo-instagram", link: "#" },
    { name: "logo-facebook", link: "#" },
    { name: "logo-linkedin", link: "#" },
  ];

  const handleSocialMedia = (key) => {
    if (key === "logo-facebook") {
      SocialMedia("facebook");
    }
    if (key === "logo-instagram") {
      SocialMedia("instagram");
    }
  };

  const navigate = useNavigate();

  return (
    <footer className='bg-gray-900 text-white'>
      {/* <ItemsContainer /> */}
      <div className='grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-6 sm:px-8 px-5 py-16'>
        <div className='flex flex-col'>
          <div>
            <img className='w-40' src={logo_white} />
            <span className='font-notosans text-[10px] sm:text-sm mx-3 font-bold text-gray-400'>
              IT services and IT consulting
            </span>
          </div>
          <div></div>
        </div>
        <div className='font-notosans'>
          <p className='text-2xl'>Our Products</p>
          <ul className='text-sm mt-5 text-gray-400'>
            <Link to='/products/transbillbook'>
              <li className='cursor-pointer'>TransBillbook</li>
            </Link>
            <Link to='/products/votersync'>
              <li className='cursor-pointer'>VoterSync</li>
            </Link>

            <Link to='/products/ecommersedashboard'>
              <li className='cursor-pointer'>E-Commerce Dashboard</li>
            </Link>
          </ul>
        </div>
        <div className='font-notosans'>
          <p className='text-2xl'>Services</p>
          <ul className='text-sm mt-5 text-gray-400'>
            <Link to='/web-development'>
              <li className='cursor-pointer'>Web Development</li>
            </Link>
            <Link to='/database-migration'>
              <li className='cursor-pointer'>Database Migration</li>
            </Link>
            <Link to='/bi-analytics'>
              <li className='cursor-pointer'>AI Solutions</li>
            </Link>
            <Link to='/cloud-management'>
              <li>Cloud Management Services</li>
            </Link>
            <Link to='/cloud-migration'>
              <li>Cloud Migration</li>
            </Link>
            <Link to='/cloud-consultation'>
              <li>Cloud Consulting</li>
            </Link>
          </ul>
        </div>
        {/* <div className="font-notosans">
          <p className="text-2xl">Solutions</p>
          <ul className="text-sm mt-5 text-gray-400">
            <li className="cursor-pointer">
              <a href="#solutions" >
                Static Web Apps
                </a>
                </li>
            <li className="cursor-pointer"><a href="#solutions">
            Dynamic Web Apps
              </a></li>
            <li className="cursor-pointer"><a href="#solutions">
            E-Commerce Web Apps
              </a></li>
            <li className="cursor-pointer"><a href="#solutions">
            Business Web Apps
              </a></li>
          </ul>
        </div> */}
        <div className='font-notosans'>
          <p className='text-2xl'>Contact Us</p>
          <ul className='text-sm mt-5 text-gray-400'>
            <li>
              <span className='font-semibold'>Address</span>: Office No:S-17,
              2nd Floor,
            </li>
            <li>Haware Fantasia Business Park,</li>
            <li>Vashi, Navi Mumbai-400703, India</li>
            <li>
              <span className='font-semibold'>Phone</span>: +91 7977954690
            </li>
            <li>
              <span className='font-semibold'>Email</span>:
              info@flintinfotech.com, sales@flintinfotech.com
            </li>
            <li>GST No. 27AAJFF4779L1ZP</li>
          </ul>
        </div>
      </div>
      <div
        className='flex flex-col-reverse md:flex-row justify-start md:justify-between gap-4 md:gap-1 md:px-8 px-5
        text-center pt-2 text-gray-400 text-sm pb-[20vw] lg:pb-8'
      >
        <div className='flex justify-start md:justify-center items-center gap-2'>
          <div>
            <span>
              © {new Date().getFullYear()} Flint Infotech. All rights reserved.
            </span>
          </div>
        </div>

        <div className='flex justify-start md:justify-center items-center gap-2'>
          <div
            className='cursor-pointer hover:text-blue-800'
            onClick={(e) => navigate("/privacy-policy")}
          >
            <span>Privacy Policy</span>
          </div>
          <div>|</div>
          {/* <div className="cursor-pointer hover:text-blue-800">
            <span>Terms</span>
          </div>
          <div>|</div> */}
          <div
            className='cursor-pointer hover:text-blue-800'
            onClick={(e) => navigate("/disclaimer")}
          >
            <span>Disclaimer</span>
          </div>
        </div>

        {/* <SocialIcons Icons={Icons} /> */}
        <div className='text-teal-500 relative flex lg:right-[5rem]'>
          {Icons.map((icon) => (
            <span
              key={icon.name}
              className='p-2 cursor-pointer inline-flex items-center
            rounded-full bg-gray-700 mx-1.5 text-xl hover:text-gray-100 hover:bg-teal-500
            duration-300 '
            >
              <ion-icon
                onClick={() => handleSocialMedia(icon.name)}
                name={icon.name}
              ></ion-icon>
            </span>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
